import { createFileRoute } from '@tanstack/react-router'
import ConversingTogetherArchive from '@/components/Exercises/Conversing-Together/archivePage/ConversingTogetherArchive'

export const Route = createFileRoute(
  '/(content)/adults/exercises/(shared)/conversing-together/archive',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <ConversingTogetherArchive />
  )
}
